<template>
  <generic-modal
    :title="$t('destinatary')"
    ref="generic_modal"
    size="fullscreen"
  >
    <div class="columns">
      <div class="column is-6">
        <div class="box">
          <h4 class="title is-5">{{ $t("basic information") }}</h4>

          <div class="field">
            <label class="label">{{ $t("dpi") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="destinatary.dpi"
                readonly
              />
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("email") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="destinatary.email"
                readonly
              />
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("phone") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="destinatary.phone"
                readonly
              />
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("destinatary type") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="destinatary.destinatary_type?.name"
                readonly
              />
            </div>
          </div>
        </div>
      </div>

      <div class="column is-6">
        <div class="box" v-if="destinatary.renap_data">
          <h4 class="title is-5">{{ $t("renap data") }}</h4>

          <div class="field" v-if="destinatary.renap_data.FOTO">
            <label class="label">{{ $t("photo") }}</label>
            <div class="control">
              <figure class="image is-128x128">
                <img
                  :src="'data:image/jpeg;base64,' + destinatary.renap_data.FOTO"
                  alt="Foto DPI"
                />
              </figure>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("first name") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :value="destinatary.renap_data.PRIMER_NOMBRE"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("second name") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :value="destinatary.renap_data.SEGUNDO_NOMBRE"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("first lastname") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :value="destinatary.renap_data.PRIMER_APELLIDO"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("second lastname") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :value="destinatary.renap_data.SEGUNDO_APELLIDO"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("cui") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="destinatary.renap_data.CUI"
                readonly
              />
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("birth date") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :value="destinatary.renap_data.FECHA_NACIMIENTO"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("gender") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :value="getGenderText(destinatary.renap_data.GENERO)"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("nationality") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="destinatary.renap_data.NACIONALIDAD"
                readonly
              />
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("marital status") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="
                  getMaritalStatusText(destinatary.renap_data.ESTADO_CIVIL)
                "
                readonly
              />
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("occupation") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="destinatary.renap_data.OCUPACION"
                readonly
              />
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("neighborhood") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :value="destinatary.renap_data.VECINDAD"
                readonly
              />
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("birth place") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :value="getNacimientoCompleto()"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("dpi expiration date") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :value="destinatary.renap_data.FECHA_VENCIMIENTO"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("id order") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :value="destinatary.renap_data.ORDEN_CEDULA"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("id registry") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :value="destinatary.renap_data.REGISTRO_CEDULA"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box" v-else>
          <h4 class="title is-5">{{ $t("renap data") }}</h4>
          <div class="notification is-warning">
            <p>{{ $t("no renap data available") }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- PATRÓN CORRECTO: usar v-slot:footer -->
    <template v-slot:footer>
      <button class="button" @click="close_modal">
        <span class="icon">
          <i class="fa fa-times"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import { post, put, get, success_message, error_message } from "@/utils";
import moment from "moment";

export default {
  name: "DestinataryViewModal",
  components: { GenericModal },
  data() {
    return {
      destinatary: {},
      error: "",
    };
  },
  computed: {},
  methods: {
    show(uuid) {
      let v = this;
      v.$refs.generic_modal.show_modal();
      get("/account-request/destinatary", { uuid: uuid })
        .then((response) => {
          v.destinatary = response;
        })
        .catch((error) => {
          v.error = error_message(error);
        });
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    set_initial_state() {
      this.request = {};
      this.error = "";
    },
    formatDate(dateString) {
      if (!dateString) return "";
      return moment(dateString).format("DD/MM/YYYY HH:mm");
    },
    getGenderText(gender) {
      if (!gender) return "";
      return gender === "M"
        ? "Masculino"
        : gender === "F"
        ? "Femenino"
        : gender;
    },
    getMaritalStatusText(status) {
      if (!status) return "";
      const statuses = {
        S: "Soltero/a",
        C: "Casado/a",
        D: "Divorciado/a",
        V: "Viudo/a",
        U: "Unido/a",
      };
      return statuses[status] || status;
    },
    getNacimientoCompleto() {
      if (!this.destinatary.renap_data) return "";
      const { PAIS_NACIMIENTO, DEPTO_NACIMIENTO, MUNI_NACIMIENTO } =
        this.destinatary.renap_data;

      let lugar = "";
      if (MUNI_NACIMIENTO) lugar += MUNI_NACIMIENTO;
      if (DEPTO_NACIMIENTO) lugar += (lugar ? ", " : "") + DEPTO_NACIMIENTO;
      if (PAIS_NACIMIENTO) lugar += (lugar ? ", " : "") + PAIS_NACIMIENTO;

      return lugar;
    },
  },
};
</script>

<style scoped>
.box {
  margin-bottom: 1rem;
}

.field {
  margin-bottom: 0.75rem;
}

.label {
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
}

.input[readonly] {
  /* background-color: #f5f5f5; */
  border-color: #dbdbdb;
  /* color: #363636; */
}

.image img {
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.title.is-5 {
  margin-bottom: 1rem;
  /* color: #363636; */
  border-bottom: 1px solid #dbdbdb;
  padding-bottom: 0.5rem;
}

.notification.is-warning {
  /* background-color: #fff3cd; */
  /* color: #856404; */
  border: 1px solid #ffeaa7;
}
</style>
